<template>
    <b-modal ref="profile_modal"
             size="sm"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
					<span class="fw-300">

					</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-container show">
                        <div class="panel-content mb-0">
                            <div class="user_auth">
                                <form class="user" autocomplete="off">
                                    <div class="form-group">
                                        <label class="form-label" for="input-live-feedback_username">
                                            {{__t('YELO_API_KEY')}}
                                        </label>
                                        <b-form-input
                                            id="input-live-feedback_username"
                                            v-model="user_form.api_key"
                                            class="form-control form-control-use"
                                            placeholder="Логин">
                                        </b-form-input>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label" for="input-live-feedback_username">
                                            {{__t('YELO_MERCHANT_USER_ID')}}
                                        </label>
                                        <b-form-input
                                            id="input-live-feedback_username"
                                            v-model="user_form.merchant_user_id"
                                            class="form-control form-control-use"
                                            placeholder="Логин">
                                        </b-form-input>
                                    </div>




                                </form>
                            </div>
                        </div>
                    </div>
                </b-overlay>

            </div>
            <!--FOOTER -->
        </div>

        <template v-slot:modal-footer="{close}">

            <div class="modal-footer">
                <div class="form-group">
                    <b-button :disabled="!can_work" class="btn btn-success btn-user btn-block" v-on:click="save_settings">
                        {{__t('SAVE')}}
                    </b-button>
                </div>
            </div>
        </template>


    </b-modal>
</template>

<script>
import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
});

export default {
    name: "yelo_auth",
    props : {
        modal_position : {
            type : String,
            default : "left"
        },
    },
    data() {
        return  {
            is_show_modal : false,
            is_load : false,
            user_form : {
                id : 0,
                api_key             : "",
                merchant_user_id    : "",
            },
        }
    },
    created() {
        EventBus.$on("yelo_auth_user",this.work_click);

    },
    methods : {
        close_modal() {
            this.close()
        },
        close() {
            this.is_show_modal = false;
        },

        work_click() {
            this.is_show_modal = true;
            this.load_settings();
        },

        async load_settings() {
            this.is_load = true;
            await agr_api.get('/aggregators/yelo/api_settings').then(({data}) => {
                this.is_load = false;
                if(data.status == "operation_success") {
                    this.user_form = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async save_settings () {
            _core.showloading();
            this.show_frame = false;
            this.auth_url = "";
            await agr_api.put('/aggregators/yelo/api_settings',this.user_form).then(({data}) => {
                this.close();
                _core.hideloading();
            }).catch(({response}) => {
                this.is_load = false;
                _core.hideloading();
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },

    computed : {
        ...mapFields([
            'user',
            'module'
        ]),
        userpass_state() {
            return this.user_form.api_key.length > 3;
        },

        can_work () {
            return this.userpass_state;
        },
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }

            return "modal-dialog-right modal-lg";
        },
    }
}
</script>

<style scoped>

</style>
